import { Box, Typography } from "@mui/material";

export const NutritionBadgeBgColor = [];

const NutritionBadge = ({
    attribute,
    value,
}) => {
    if (!attribute) return null;

    const imgSrc = attribute.image || attribute.icon;

    return (
        <Box
            key={attribute._idAttribute}
            sx={{
                width: 48,
                height: 42,
                position: 'relative',
            }}
        >
            <Box sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
            }}>
                <Box
                    sx={{
                        borderRadius: '8px',
                        position: 'absolute',
                        top: 0,
                        width: 'fit-content',
                        minWidth: 24,
                        maxWidth: 50,
                        padding: '4px 8px',
                        overflow: 'hidden',
                        zIndex: 1,
                        maxWidth: '2rem',
                    }}
                >
                    <Typography
                        sx={{
                            color: '#000',
                            fontWeight: 400,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textAlign: 'center',
                            fontSize: "0.85rem",
                            lineHeight: "1.25rem",
                        }}
                    >
                        {value}
                    </Typography>
                </Box>
            </Box>
            <img
                src={imgSrc}
                alt={attribute.name}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                }}
            />
        </Box>
    );
};

export default NutritionBadge;